import React from 'react';
import { CTAButton } from './CTAButton';
export function MidCTA() {
  return <section className="w-full bg-cream px-5 py-10 md:py-16" data-id="element-167">
      <div className="mx-auto flex max-w-container flex-col items-center text-center" data-id="element-168">
        <p className="mb-3 text-[13px] text-burgundy" data-id="element-169">
          Más de 200 mujeres compraron esta guía esta semana
        </p>
        <CTAButton className="w-full max-w-md" data-id="element-170">
          Quiero mi guía ahora · $10
        </CTAButton>
      </div>
    </section>;
}